export interface zohoFormData {
  First_Name?: string;
  Last_Name?: string;
  Email?: string;
  Phone_Number?: number;
  Company?: string;
  Description?: string;
  Rating?: string
  Lead_Source?: string
  reCaptcha: boolean
}

export interface zohoFormInfo {
  successElement: HTMLDivElement | null;
  errorElement: HTMLDivElement | null;
  formElement: HTMLElement | null;
}


const zohoSender = (formData: zohoFormData, formElements: zohoFormInfo, setLoading: Function) => {
  const apiUrl = process.env.GATSBY_CLIENT_API_URL
  const url = `${apiUrl}/puxapi/zoho/lead`
  const zohoPayload = JSON.stringify({
    data: [formData]
  });

  const successMessage = formElements.successElement;
  const errorMessage = formElements.errorElement;
  const form = formElements.formElement;

  if (form) {
    form.style.display = "none";
  }

  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: zohoPayload,
  })
    .then((response) => {
      // return response.json()
      if (response.status === 201) {
        return response
      } else if (response.status === 202) {
        response.json().then(data => { throw data.message })
      } else {
        throw "Zoho api error"
      }
    })
    .then(() => {
      setLoading(false);
      if (successMessage) {
        successMessage.style.display = "block";
        successMessage.scrollIntoView();
      }
    })
    .catch((error) => {
      setLoading(false);
      console.error("Error:", error);
      if (errorMessage) {
        errorMessage.style.display = "block";
      }
    });
};

export default zohoSender;
